module.exports = __webpack_public_path__ + "img/horizontal_6_2_7016.9a9641a4.png";